import { cipo } from 'cipo';

cipo.controller('sutntController',
function ($scope, $state) {

});
